import { View } from "@react-pdf/renderer";
import { ResumePDFHighlightableText, ResumePDFText } from "components/Resume/ResumePDF/common";
// import { RessumePDFHighlightableText } from "./common/index/
import { TemplateTwelvePDFSection } from "./common";

export const Summary = ({
  heading,
  summary,
  themeColor,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  heading: string;
  summary: string;
  themeColor: string;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  return (
    <TemplateTwelvePDFSection themeColor={themeColor} heading={heading}>
      <View>
        {summary && (enableHighlight || enableMistakeHighlight)  ? (
          <ResumePDFHighlightableText
            text={summary}
            section="profile"
            itemIndex={null}
            style={{ color: themeColor }}
            enableMistakeHighlight={enableMistakeHighlight}
          />
        )
         : (
          <ResumePDFText themeColor={themeColor}>{summary}</ResumePDFText>
         )
        }
      </View>
    </TemplateTwelvePDFSection>
  );
};
